import { MasterCardLogo } from "../icons/MasterCardLogo";
import {VisaLogo} from "../icons/VisaLogo";

type CreditCardLogosProps = {
    size?: number | string | undefined;
    height?: number | string | undefined;
    className?: string | undefined;
    onClick?: (() => void) | undefined;
}


export const CreditCardLogos = (props: CreditCardLogosProps) => {
    return (
        <span className="inline-flex gap-2 align-middle">
            <span className="inline-block align-text-bottom">
                <VisaLogo size={props.size} height={props.height}/>
            </span>
            <span className="inline-block align-text-bottom">
                <MasterCardLogo size={props.size} height={props.height} />
            </span>
        </span>
    );
};
